
import Vue from 'vue';
import AppClass from '@modules/husleie-framework/src/static-classes/App.class';
import LogoDesktopGER from '@modules/design-system/components/atoms/icons/IconLogoDesktopGER.vue';
import LogoMobileGER from '@modules/design-system/components/atoms/icons/IconLogoMobileGER.vue';
import LogoDesktopNOR from '@modules/design-system/components/atoms/icons/IconLogoDesktopNOR.vue';
import LogoMobileNOR from '@modules/design-system/components/atoms/icons/IconLogoMobileNOR.vue';

export default Vue.extend({
  name: 'FunnelHeader',

  components: {
    'a-LogoDesktopGER': LogoDesktopGER,
    'a-LogoMobileGER': LogoMobileGER,
    'a-LogoDesktopNOR': LogoDesktopNOR,
    'a-LogoMobileNOR': LogoMobileNOR,
  },
  computed: {
    isNorway(): boolean {
      if (this.getMarketIdentifier === 'NOR') return true;
      return false;
    },
    isGermany(): boolean {
      if (this.getMarketIdentifier === 'GER') return true;
      return false;
    },
    getMarketIdentifier(): string | undefined {
      return AppClass.getMarketIdentifier();
    },
  },
});
